import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function PortfolioSection() {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const projects = [
    {
      id: 1,
      title: 'مشروع التطوير المؤسسي الشامل',
      category: 'تطوير مؤسسي',
      image: 'https://public.readdy.ai/ai/img_res/6659cd20bf427576304d1f827657fdd1.jpg',
      description: 'تطوير شامل للهيكل التنظيمي والعمليات'
    },
    {
      id: 2,
      title: 'استشارات استراتيجية متقدمة',
      category: 'استشارات',
      image: 'https://readdy.ai/api/search-image?query=strategic%20consulting%20project%20with%20business%20executives%20reviewing%20plans%20and%20strategies%20in%20modern%20boardroom%20with%20simple%20background&width=600&height=400&seq=portfolio-002&orientation=landscape',
      description: 'وضع خطة استراتيجية خمسية للنمو'
    },
    {
      id: 3,
      title: 'إدارة مشروع تحول رقمي',
      category: 'إدارة مشاريع',
      image: 'https://readdy.ai/api/search-image?query=digital%20transformation%20project%20management%20with%20technology%20implementation%20in%20modern%20corporate%20setting%20with%20clean%20background&width=600&height=400&seq=portfolio-003&orientation=landscape',
      description: 'قيادة التحول الرقمي الكامل للمؤسسة'
    },
    {
      id: 4,
      title: 'برنامج تدريب القيادات',
      category: 'تدريب',
      image: 'https://readdy.ai/api/search-image?query=leadership%20training%20program%20with%20executives%20learning%20management%20skills%20in%20professional%20training%20facility%20with%20simple%20background&width=600&height=400&seq=portfolio-004&orientation=landscape',
      description: 'تأهيل 50+ قيادي في مهارات الإدارة'
    },
    {
      id: 5,
      title: 'دراسة جدوى اقتصادية',
      category: 'دراسات',
      image: 'https://readdy.ai/api/search-image?query=economic%20feasibility%20study%20with%20financial%20analysis%20and%20market%20research%20documents%20in%20professional%20office%20with%20clean%20background&width=600&height=400&seq=portfolio-005&orientation=landscape',
      description: 'دراسة شاملة لمشروع استثماري كبير'
    },
    {
      id: 6,
      title: 'تخطيط استراتيجي متكامل',
      category: 'تخطيط',
      image: 'https://readdy.ai/api/search-image?query=comprehensive%20strategic%20planning%20session%20with%20business%20roadmap%20and%20vision%20planning%20in%20modern%20workspace%20with%20simple%20background&width=600&height=400&seq=portfolio-006&orientation=landscape',
      description: 'بناء رؤية ورسالة وأهداف استراتيجية'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
            أعمالنا
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            سابقة الأعمال
          </h2>
          <p className="text-lg text-gray-600">
            نفخر بإنجازاتنا ومشاريعنا الناجحة التي حققت نتائج متميزة لعملائنا
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div 
              key={project.id}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              {/* Image */}
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500 cursor-pointer"
                  onClick={() => setSelectedImage(project.image)}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                
                {/* Category Badge */}
                <div className="absolute top-4 right-4 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-lg">
                  <span className="text-sm font-semibold text-blue-600">{project.category}</span>
                </div>

                {/* Overlay Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-xl font-bold text-white mb-2">
                    {project.title}
                  </h3>
                  <p className="text-white/90 text-sm mb-4">
                    {project.description}
                  </p>
                  <Link 
                    to={`/portfolio/${project.id}`}
                    className="inline-flex items-center gap-2 text-white hover:text-blue-300 font-semibold transition-colors cursor-pointer"
                  >
                    عرض التفاصيل
                    <i className="ri-arrow-left-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link 
            to="/portfolio"
            className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            عرض جميع الأعمال
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-6xl w-full">
            <button 
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 left-0 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center text-white transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <img 
              src={selectedImage}
              alt="Preview"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
}